(function (ws) {
    'use strict';
    ws.collections.addTableProductsCollection = Backbone.Collection.extend({
        url: globals.path.api.quoting.productTableAddToQuoteUrl,

        /**
         * Sync entire collection
         * @returns {*}
         */
        save: function() {
            return Backbone.sync('create', this, {
                url: this.url,
                contentType: 'application/json',
                data: JSON.stringify({
                    productList: this.pluck('partsNo').join('\n'),
                    quoteId: $('#quoteCode').val()
                })
            });
        }
    });
}(westcon));
